import React from 'react';
import { useTranslation } from 'react-i18next';
import { FATAL_ERROR_NOTICE_TYPES } from '@kallidus/common';
import ErrorPage from './ErrorPage';

const AccessDeniedPage = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage type={FATAL_ERROR_NOTICE_TYPES.FORBIDDEN} title={t('access-denied-page.title')}>
      {t('access-denied-page.message')}
    </ErrorPage>
  );
};

export default AccessDeniedPage;
